export default {
	currentRoute: (state, getters, rootState) => rootState.route,
	isFirstStep: (state, getters) => !getters.currentRoute.query.s ||
			getters.currentRoute.query.s === state.steps.login,
	isSecondStep: (state, getters) => getters.currentRoute.query.s === state.steps.submitSmsCode,
	isThirdStep: (state, getters) => getters.currentRoute.query.s === state.steps.wait
}
